module.exports = "/_next/static/images/Privacy-md@2x-e4e7b9cb11df2d4c3bcaceb6081aec98.webp";